import { spacings } from "@/assets/themes";
import { Block, Button, NoResult, Skeleton } from "@/components";
import { BUTTON } from "@/components/Styles/variants";
import { useAskService } from "@/modules/hooks";
import {
  useGetRecurringJobsJobbers,
  useRecurringJobsFormData,
} from "@/modules/routes/recurring-jobs-routes";
import { useFormikContext } from "formik";
import polyglot from "@/utils/polyglot";
import {
  FormCardSelectables,
  StyledFormControl,
} from "../categoryForms/common/fields";
import StepTitle from "../categoryForms/common/StepTitle";

const JobberSelection = ({ title }) => {
  const { values } = useFormikContext();

  const { data, isLoading } = useGetRecurringJobsJobbers();

  useRecurringJobsFormData(
    {
      jobber_id: values.private_jobber_id,
    },
    { enabled: !!values.private_jobber_id }
  );

  const askService = useAskService();

  const options = data?.jobbers?.map((jobber) => ({
    value: jobber.id,
    label: jobber.first_name,
    image: jobber.avatar,
  }));

  if (isLoading)
    return (
      <>
        <StepTitle>{title}</StepTitle>
        <StyledFormControl>
          <Skeleton.Group>
            <Block display="grid" gridCols={{ xs: 2, md: 3 }} gap={spacings.s}>
              {Array.from({ length: 6 }).map((_, index) => (
                <Skeleton
                  key={`skeleton-${index}`}
                  css={`
                    width: 100%;
                    aspect-ratio: 1/1;
                  `}
                />
              ))}
            </Block>
          </Skeleton.Group>
        </StyledFormControl>
      </>
    );
  return (
    <>
      <StepTitle>{title}</StepTitle>
      <StyledFormControl>
        {data?.jobbers?.length > 0 ? (
          <FormCardSelectables options={options} name="private_jobber_id" />
        ) : (
          <NoResult
            title={polyglot.t("recurring.no_jobber_available")}
            subtitle={polyglot.t("recurring.no_jobber_available_subtitle")}
          >
            <Button.Large
              kind={BUTTON.KIND.SECONDARY}
              onClick={() => askService.show()}
            >
              {polyglot.t("jobs.ask_service")}
            </Button.Large>
          </NoResult>
        )}
      </StyledFormControl>
    </>
  );
};

export default JobberSelection;
